

<div class="login-container m-auto">
  <div class="card boxshadow">    

    <div class="card-body">

      <div class="row">

        <!-- Email Status Dropdown -->
        <div class="col-md-4 mb-3">
          <label class="form-label">Email Status</label>
          <ng-select [searchable]="true"
                     [clearable]="true"
                     (change)="filterByStatus($event)">
            <ng-option *ngFor="let status of emailStatuses" [value]="status">
              {{ status }}
            </ng-option>
          </ng-select>
        </div>

        <!-- Created Date From -->
        <div class="col-md-4 mb-3">
          <label class="form-label">Created Date From</label>
          <input type="date"
                 class="form-control"
                 [(ngModel)]="createdDateFrom"
                 (change)="filterByDateRange()" />
        </div>

        <!-- Created Date To -->
        <div class="col-md-4 mb-3">
          <label class="form-label">Created Date To</label>
          <input type="date"
                 class="form-control"
                 [(ngModel)]="createdDateTo"
                 (change)="filterByDateRange()" />
        </div>
        <div class="col-md-2 align-self-end">
          <button class="btn btn-danger w-100" (click)="clearAllFilters()">Clear All Filters</button>
        </div>

      </div>

      <div class="col-md-12">

        <div class="form-group mb-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-success" data-toggle="modal" data-target="#emailCompositionModal">
              <i class="fa fa-envelope"></i> New Email
            </button>
          </div>
        </div>

        <div style="overflow-x: auto;">
          <table id="tbldata" datatable [dtOptions]="dtOptions" class="table table-striped table-hover dt-responsive" style="width:100%">
          </table>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Include Email Composition Component -->
<app-email-composition></app-email-composition>

<style>
  #tbldata {
    margin-bottom: 0;
  }

  #tbldata thead {
    background-color: #f5f5f5;
  }

  #tbldata tbody tr:hover {
    background-color: #f9f9f9;
  }

  .send-email-btn {
    padding: 5px 10px;
    font-size: 12px;
  }

  .dt-responsive table.dataTable tbody td {
    padding: 8px;
    word-break: break-word;
    white-space: normal;
  }

  /* Wide Popover styling - Minimum 400-500px */
  .popover {
    min-width: 450px !important;
    max-width: 550px !important;
    width: 500px !important;
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem !important;
    position: relative !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    display: block !important;
  }

  .popover.bs-popover-right {
    margin-left: 0.5rem !important;
  }

  .popover.bs-popover-left {
    margin-right: 0.5rem !important;
  }

  /* Responsive popover for smaller screens */
  @media (max-width: 768px) {
    .popover {
      min-width: 320px !important;
      max-width: 400px !important;
      width: calc(100vw - 40px) !important;
      left: 20px !important;
      right: 20px !important;
    }
  }

  .popover-header {
    background-color: #007bff !important;
    color: white !important;
    font-weight: 600 !important;
    border-bottom: 1px solid #0056b3 !important;
    padding: 10px 15px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .popover-close-btn {
    position: absolute !important;
    top: -35px !important;
    right: 0 !important;
    background: #dc3545 !important;
    color: white !important;
    border: none !important;
    padding: 5px 10px !important;
    border-radius: 3px !important;
    cursor: pointer !important;
    font-size: 18px !important;
    font-weight: bold !important;
    transition: background-color 0.2s ease !important;
    z-index: 1000 !important;
  }

  .popover-close-btn:hover {
    background-color: #c82333 !important;
  }

  .popover-body {
    min-height: 300px !important;
    max-height: 500px !important;
    overflow-y: auto !important;
    word-wrap: break-word !important;
    white-space: normal !important;
    padding: 15px !important;
    font-size: 13px !important;
    line-height: 1.6 !important;
    overflow-x: hidden !important;
    background-color: #f8f9fa !important;
  }

  .bs-popover-right > .arrow::before,
  .bs-popover-left > .arrow::before {
    border-right-color: #dee2e6 !important;
  }

  .email-popover-wide {
    min-width: 450px !important;
    max-width: 550px !important;
    width: 500px !important;
  }

  .email-popover-wide.show {
    min-width: 450px !important;
    max-width: 550px !important;
    width: 500px !important;
    display: block !important;
  }

  .email-body-preview {
    cursor: pointer;
    color: #007bff;
    text-decoration: underline;
    transition: color 0.2s ease;
  }

  .email-body-preview:hover {
    color: #0056b3;
    text-decoration: none;
  }

  .email-subject-tooltip {
    cursor: pointer;
    color: #007bff;
    transition: color 0.2s ease;
    word-break: break-word;
    white-space: normal;
    display: inline-block;
    max-width: 100%;
  }

  .email-subject-tooltip:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  .email-subject-tooltip:focus {
    outline: none;
  }

  .email-tooltip-content {
    word-wrap: break-word;
    white-space: normal;
    max-width: 100%;
    overflow-x: hidden;
  }

  .email-tooltip-content div {
    margin-bottom: 8px;
    word-break: break-word;
    overflow-x: hidden;
  }

  .email-tooltip-content strong {
    color: #333;
    font-weight: 600;
  }

  /* Ensure email body content doesn't overflow */
  .email-tooltip-content div[style*="overflow-y: auto"] {
    overflow-x: hidden !important;
    word-wrap: break-word !important;
    width: 100% !important;
  }

  .d-flex {
    display: flex;
  }

  .gap-2 {
    gap: 0.5rem;
  }
</style>

<!-- Email Details Modal (replaces popover) -->
<div class="modal fade" id="emailDetailsModal" tabindex="-1" aria-labelledby="emailDetailsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable" [ngClass]="isEmailModalExpanded ? 'email-modal-expanded' : 'modal-lg'">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="emailDetailsModalLabel">Email Details</h5>
        <div class="ms-auto d-flex align-items-center">
          <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="toggleEmailModalSize()"
                  [title]="isEmailModalExpanded ? 'Collapse' : 'Expand'">
            <i class="fa" [ngClass]="isEmailModalExpanded ? 'fa-compress' : 'fa-expand'"></i>
            {{ isEmailModalExpanded ? 'Collapse' : 'Expand' }}
          </button>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="email-body-container" [innerHTML]="currentEmailHtml"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
